import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-between h-100" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_input_text_editor = _resolveComponent("input-text-editor")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "has-build-status-on-page": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('notificationTemplate'),
        mode: _ctx.PageDetailModeEnum.EDIT
      }, null, 8, ["title", "mode"]),
      _createVNode(_component_GenericFormWrapper, {
        submitData: _ctx.submitData,
        pageUI: _ctx.pageUI
      }, {
        content: _withCtx(({errors}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('type')) + " : " + _toDisplayString(_ctx.notificationType), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('subType')) + " : " + _toDisplayString(_ctx.notificationTemplate?.discriminator ?? '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_input_select, {
                  modelValue: _ctx.template.comm_type_code,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.template.comm_type_code) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  label: _ctx.$t('communicationType'),
                  name: _ctx.$t('communicationType'),
                  options: _ctx.allCommunicationTypes,
                  rules: "required",
                  errors: errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "options", "errors"])
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('language')) + " : " + _toDisplayString(_ctx.notificationTemplate?.language_code ?? '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_input_text, {
                  modelValue: _ctx.template.subject,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.template.subject) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  label: _ctx.$t('subject'),
                  name: "subject",
                  errors: errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_input_text_editor, {
                  modelValue: _ctx.template.content,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.template.content) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  label: _ctx.$t('content'),
                  rules: "required",
                  name: "content",
                  errors: errors
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "errors"])
              ])
            ])
          ])
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_base_offcanvas_button_close, {
            id: "notificationTemplateOffCanvasCloseButton",
            class: "btn btn-light",
            disabled: _ctx.pageUI.isSubmitting()
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["submitData", "pageUI"])
    ]),
    _: 1
  }))
}